export enum ExportEnum {
  COPY_LINK = 'Copy Link',
  PDF = 'Save as PDF',
  QR_CODE = 'Get the QR Code',
}
export enum ExportStatusEnum {
  READY_TO_START,
  STARTED,
  DONE,
}

export enum HexCodeConverterEnum {
  RGB = 'rgb',
  RYB = 'ryb',
}

export enum UploadFilePosition {
  UPLOAD_AREA = 1,
  BUTTON,
  ALERT,
  START_OVER,
}
